import { createMemo } from "solid-js";
import type { useTheme } from "@/providers/theme-provider";
import { getGlowColors } from "../helpers";

interface AppThemeStateOptions {
  theme: ReturnType<typeof useTheme>;
}

/**
 * Layout-level theme state. After retiring the listto domain only the
 * user's global theme exists (no per-list themes or task drawer).
 */
export function useAppThemeState(options: AppThemeStateOptions) {
  const globalTheme = createMemo(
    () => options.theme.allThemes()?.find((r) => r.target_id === "global") ?? null,
  );

  const activeBlur = createMemo(() => options.theme.isBlur());

  const activeBackground = createMemo(() => options.theme.tokens()?.background);

  const glows = createMemo(() => getGlowColors(globalTheme(), options.theme.tokens()));

  return {
    globalTheme,
    activeBlur,
    activeBackground,
    glows,
  };
}
